import { gql } from '@apollo/client'

import { UserBase, UserStats } from './types'

// Get User Stats

export type GetUserStats = {
  user: UserBase & UserStats
}

export const QUERY_GET_USER_STATS = gql`
  query GetUser($id: String!) {
    user: user_by_pk(id: $id) {
      id
      flagged
      createdAt: created_at
      createdAtBlock: created_at_block
      updatedAt: updated_at
      transactions
      contracts
      totalCollections: collections_aggregate {
        agg: aggregate {
          count
        }
      }
      totalItems: tokens_aggregate {
        agg: aggregate {
          count
        }
      }
    }
  }
`
